import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1F4B3F",
    },
    required: {
      main: "#FF0000",
    },
    white: {
      main: "#FFFFFF",
    },
    black: {
      main: "#000000",
    },
    layout: {
      main: "#FDF6E3",
    },
    buttonHover: {
      main: "#1F4B3F",
      secondary: "#2F5F51",
    },
    button: {
      logout: "#D84315",
      logoutHover: "#D3D3D3",
    },
  },
});

export default theme;
